module.exports = __webpack_public_path__ + "img/d_zycc.2c845702.jpg";